// https://stackoverflow.com/questions/47176280/how-to-convert-files-to-base64-in-react/51636498
export const toBase64 = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve((reader.result as string).split(",").pop() as string)
        reader.onerror = error => reject(error)
    })

export const removeExtension = (fileName: string): string => {
    return fileName.substr(0, fileName.lastIndexOf("."))
}
